import { iaRa } from 'lib/helpers/utility';

const sortByColumnOrder = (fields, source) =>
  iaRa(fields)
    .slice()
    .sort(
      (a, b) =>
        source.findIndex((col) => col.field === a) - source.findIndex((col) => col.field === b)
    )
    .map((field) => source.find((col) => col.field === field));

export const resolveExportColumns = ({ values, columns, childColumns, hasExpandableRows }) => {
  const isDetailedMode = hasExpandableRows && values.export_data === 'detailed';
  const isExportAllColumns = values.export_columns.includes('all');
  const activeColumns = isDetailedMode ? childColumns : columns;

  if (isExportAllColumns) {
    return {
      isDetailedMode,
      isExportAllColumns,
      finalColumns: activeColumns,
      finalParentColumns: columns
    };
  }

  return {
    isDetailedMode,
    isExportAllColumns,
    finalColumns: sortByColumnOrder(values.selected_columns, activeColumns),
    finalParentColumns: isDetailedMode
      ? sortByColumnOrder(values.selected_parent_columns, columns)
      : columns
  };
};
